<template>
  <v-container class="lx-page">
    <div class="lx-page-head">
      <span class="kicker">Janus4cast · H2F2</span>
      <h1>
        Welcome back,
        {{
          getMe.firstName
            ? getMe.firstName[0].toUpperCase() + getMe.firstName.slice(1)
            : ""
        }}
      </h1>
      <h4 class="mt-2">
        Emerging-market forecasting and decision intelligence. Every projection
        below is generated by the H2F2 model chain from the weekly panel.
      </h4>
      <div class="lx-status mt-4" v-if="dateFormat">
        <span class="lx-tag lx-tag--obs">Dataset updated {{ dateFormat }}</span>
      </div>
    </div>

    <span class="kicker mb-3">Forecasting tools</span>
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/medium-term-forecaster')">
          <span class="kicker">MTF</span>
          <h3>Medium-Term Forecaster</h3>
          <p>
            52-week forecasts for the sovereign CDS, the exchange rate and the
            local equity index, set against market consensus. Build alternative
            scenarios from your own macro assumptions.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/shock-simulator')">
          <span class="kicker">SIM</span>
          <h3>Short-Term Shock Simulator</h3>
          <p>
            Propagate a macro or market shock through the forecast chain and read
            the short-horizon response across each market variable.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/historical-data-visualization')">
          <span class="kicker">WDB</span>
          <h3>Weekly Database</h3>
          <p>
            The historical weekly panel behind every forecast: rates, spreads,
            currencies, equity indices and macro series by country.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>
    </v-row>

    <span class="kicker mb-3 mt-6 d-block">Comparative country tables</span>
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="redirectTab(1)">
          <span class="kicker">TAB</span>
          <h3>Medium-Term Performance</h3>
          <p>
            Cross-country ranking of expected medium-term market performance over
            the forecast horizon.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="redirectTab(2)">
          <span class="kicker">TABV</span>
          <h3>Short-Term Vulnerability</h3>
          <p>
            Cross-country comparison of short-term vulnerability to shocks,
            derived from the same model chain.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>
    </v-row>

    <span class="kicker mb-3 mt-6 d-block">Research</span>
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/backtesting')">
          <span class="kicker">OOS</span>
          <h3>Backtesting</h3>
          <p>
            Out-of-sample forecasts of H2F2 against a no-ML benchmark, replayed
            week by week against the realised data.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/trading-strategy')">
          <span class="kicker">Strategy</span>
          <h3>Trading Strategy</h3>
          <p>
            A directional rule built on Janus versus consensus, compared with
            buy-and-hold of the same market.
          </p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card class="lx-module" @click="$router.push('/white-paper')">
          <span class="kicker">Paper</span>
          <h3>White Paper</h3>
          <p>The H2F2 methodology: data, model selection and validation.</p>
          <span class="lx-module__go">Open →</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "home_",
  components: {},
  data() {
    return {
      dayUpdated: new Date().getDay(),
      monthUpdated: new Date().getMonth(),
      yearUpdated: new Date().getFullYear(),
    };
  },
  methods: {
    ...mapActions(["setDateUpdate", "setTab"]),

    redirectTab(tab) {
      this.setTab(tab);
      this.$router.push("/comparative-country-tables");
    },
  },
  computed: {
    ...mapGetters(["getMe", "getDateUpdate"]),

    dateFormat: function () {
      if (this.getDateUpdate) {
        let date = moment(this.getDateUpdate).format("D MMM YYYY");
        return date;
      }
      return this.getDateUpdate;
    },
  },
  mounted() {
    this.setDateUpdate();
  },
};
</script>
<style scoped>
.title-card {
  font-size: 24px;
  font-weight: 400;
}
@media screen and (max-width: 450px) {
  .title-card {
    font-size: 24px;
  }
}
</style>